import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { DictionaryOvssAutocomplete } from '../../models';

export function useOvss() {
  return useAutocompleteSource<DictionaryOvssAutocomplete>({
    url: `${EvidenceAPI.DICTIONARY_OVSS}/autocomplete`,
  });
}
